import { useTheme, Box, Typography } from '@mui/material';
import { tokens } from '../../../global/theme/tokens';
import MoneyLabel from '../../label/MoneyLabel';
import SpeedDialMenu from '../../menu/SpeedDialMenu';
import { useTranslation } from 'react-i18next';
import UserStack from '../UserStack';
import { renderHours } from '../../../scenes/time-tracking/worktime';

const EmployeeClass = ({ empClass, showIcon, actions }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const { t } = useTranslation();

  const { empSumHourShare } = empClass;

  return (
    <Box
      className="relative flex p-2 items-start gap-2 h-[94px]"
      sx={{
        backgroundColor: empClass.color + '30',
        borderRadius: 4,
        border: `1px solid ${empClass.color}80`,
      }}
    >
      {showIcon && empClass.image && (
        <img
          className="w-[32px] h-[32px] object-contain"
          src={empClass.image.temporaryUrl}
        />
      )}
      <Box className="w-full">
        <Typography fontWeight={600}>{empClass.label}</Typography>
        <Box className="flex justify-between gap-2">
          <Typography>
            <MoneyLabel money={empClass.wage} /> {' / h'}
          </Typography>
          {empSumHourShare && (
            <Box>
              <Typography className="monospace" fontWeight={600} fontSize={15}>
                {renderHours(empSumHourShare * 60)}
                {' h'}
              </Typography>
            </Box>
          )}
        </Box>
        <Box className="flex h-[5px] pb-1 justify-between gap-2 items-start">
          <Box className="pt-1">
            <UserStack users={empClass.users || []} />
          </Box>
          {empSumHourShare && (
            <Typography fontSize={12} className="opacity-50">
              {t('Total')}
            </Typography>
          )}
        </Box>
      </Box>
      {actions && (
        <>
          <Box className="w-[40px]" />
          <SpeedDialMenu
            key={'SpeedDialMenuEmpClass' + empClass.id}
            className="absolute right-0 top-0"
            actions={actions}
          />
        </>
      )}
    </Box>
  );
};

export default EmployeeClass;
